import { combineSlices, configureStore } from '@reduxjs/toolkit';

import createSagaMiddleware from 'redux-saga';

import { all } from 'redux-saga/effects';

// Import custom reducers and sagas:
import cookies, { cookiesSaga } from './modules/cookies';
import consent, { consentSaga } from './modules/consent';
import company, { companySaga } from './modules/company';
import sdk, { sdkSaga } from './modules/sdk';

const sagaMiddleware = createSagaMiddleware();

const reducers = combineSlices({
	cookies,
	company,
	consent,
	sdk,
});

const store = configureStore({
	reducer: reducers,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({ serializableCheck: false }).concat(sagaMiddleware),
});

const persistor = store;

const rootSaga = function* () {
	yield all([companySaga(), cookiesSaga(), consentSaga(), sdkSaga()]);
};

sagaMiddleware.run(rootSaga);

export { persistor, store };
